<template>
  <div>
    <md-card>
      <md-card-header data-background-color="secondary">
        <h4 class="title">{{ mediaTitle }}</h4>
      </md-card-header>
      <md-card-content>
        <md-empty-state
          v-if="mediaData.length === 0"
          :md-description="'No ' + mediaTitle + ' Found'"
        />
        <div class="md-layout md-media-container">
          <div
            v-for="item in pageOfItems"
            :key="item.id"
            class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-50 md-small-size-50 md-xsmall-size-100"
          >
            <md-card class="md-media">
              <md-card-media>
                <img
                  :src="item.thumbnail ? item.thumbnail : item.url"
                  alt="thumbnail"
                />
              </md-card-media>
              <md-card-header>
                <div class="md-title">{{ item.title }}</div>
                <div class="md-subhead">{{ item.subtitle }}</div>
              </md-card-header>
              <md-card-actions md-alignment="space-between">
                <div>
                  <!-- <md-button
                    class="md-button-social md-secondary-outline md-fab"
                  >
                    <md-icon>share</md-icon>
                  </md-button>
                  <md-button
                    class="md-button-social md-secondary-outline md-fab"
                  >
                    <md-icon>email</md-icon>
                  </md-button> -->
                  <md-button class="md-button-social md-secondary md-fab">
                    <md-icon>download</md-icon>
                  </md-button>
                </div>
                <md-button
                  class="md-button-social md-primary md-fab"
                  @click="showModal(item)"
                >
                  <md-icon>open_in_new</md-icon>
                </md-button>
              </md-card-actions>
            </md-card>
          </div>
        </div>
        <jw-pagination
          :items="mediaData"
          :page-size="8"
          :disable-default-styles="true"
          :max-pages="5"
          @changePage="onChangePage"
        ></jw-pagination>
      </md-card-content>
    </md-card>

    <md-dialog :md-active.sync="showDialog" class="mediaModal">
      <md-dialog-title>{{ type | capitalize }}: {{ title }}</md-dialog-title>
      <md-dialog-content class="text-center">
        <div v-if="type === 'video'" class="mediaContainer w-100">
          <vue-plyr>
            <video controls crossorigin playsinline :src="url"></video>
          </vue-plyr>
        </div>
        <div v-else-if="type === 'image'" class="mediaContainer">
          <img :src="url" :alt="title" />
        </div>
        <md-table class="mediaTable text-left">
          <md-table-row>
            <md-table-cell>Title</md-table-cell>
            <md-table-cell>{{ title }}</md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell>Description</md-table-cell>
            <md-table-cell>{{ description }}</md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell>Date Added</md-table-cell>
            <md-table-cell>{{
              this.$moment(date).format("DD/MM/YYYY")
            }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-dialog-content>
      <md-dialog-actions>
        <div>
          <!-- <md-button class="md-button-social md-secondary-outline md-fab">
            <md-icon>share</md-icon>
          </md-button>
          <md-button class="md-button-social md-secondary-outline md-fab">
            <md-icon>email</md-icon>
          </md-button> -->
          <md-button class="md-button-social md-secondary md-fab">
            <md-icon>download</md-icon>
          </md-button>
          <md-tooltip md-direction="top">Download</md-tooltip>
        </div>
        <md-button class="md-disabled" @click="showDialog = false"
          >Close</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import jwPagination from "jw-vue-pagination";

export default {
  name: "MediaContainer",
  components: {
    jwPagination
  },
  props: {
    mediaTitle: {
      type: String,
      default: ""
    },
    mediaData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDialog: false,
      type: "",
      title: "",
      url: "",
      date: "",
      description: "",
      pageOfItems: []
    };
  },
  methods: {
    showModal: function(item) {
      this.type = item.type;
      this.title = item.title;
      this.subtitle = item.subtitle;
      this.description = item.description;
      this.url = item.url;
      this.date = item.created_at;
      this.showDialog = true;
    },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    }
  }
};
</script>
